import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Card, Inset } from "@radix-ui/themes";
export function Root({ children, ...props }) {
    return (_jsx(Card, { size: "2", ...props, className: "woswidgets-card-list", children: _jsx(Inset, { side: "all", clip: "padding-box", children: children }) }));
}
export function Item({ children }) {
    return (_jsx(Inset, { side: "x", px: "current", className: "woswidgets-card-list-item", clip: "padding-box", children: _jsx(Box, { px: "4", py: "4", children: children }) }));
}
//# sourceMappingURL=card-list.js.map